import { render } from "./GoldAZS.vue?vue&type=template&id=10b4bdfd&scoped=true"
import script from "./GoldAZS.vue?vue&type=script&lang=js"
export * from "./GoldAZS.vue?vue&type=script&lang=js"

import "./GoldAZS.vue?vue&type=style&index=0&id=10b4bdfd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b4bdfd"]])

export default __exports__